import { BscChainId } from 'types';

export const API_ENDPOINT_URLS = {
  [BscChainId.MAINNET]: 'https://api.dlweb3.com',
  // [BscChainId.TESTNET]: 'https://testnetapi.venus.io/api',
  [BscChainId.TESTNET]: 'http://localhost:3001',
  [BscChainId.OPBNB_MAINNET]: 'https://api.dlweb3.com', // 可以根据需要更改
  [BscChainId.OPBNB_TESTNET]: 'http://localhost:3001', // 可以根据需要更改
};

export const RPC_URLS: {
  [key: string]: string[];
} = {
  [BscChainId.MAINNET]: [
    'https://bsc-dataseed1.ninicoin.io',
    'https://bsc-dataseed1.defibit.io',
    'https://bsc-dataseed.binance.org',
  ],
  [BscChainId.TESTNET]: ['https://bsc-testnet.nodereal.io/v1/f9777f42cc9243f0a766937df1c6a5f3'],
  [BscChainId.OPBNB_MAINNET]: [
    'https://opbnb-mainnet-rpc.bnbchain.org',
    'https://opbnb-mainnet.nodereal.io/v1/f9777f42cc9243f0a766937df1c6a5f3',
    'https://opbnb-mainnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3',
  ],
  [BscChainId.OPBNB_TESTNET]: [
    'https://opbnb-testnet-rpc.bnbchain.org',
    'https://opbnb-testnet.nodereal.io/v1/f9777f42cc9243f0a766937df1c6a5f3',
  ],
};
